import axios from 'axios';
import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';
import joinExperimentsToString from '@gumtree/shared/src/util/join-experiments-to-string';
import { GrowthBookServerSideFeatures } from '@gumtree/shared/src/model/experiment';
import type { FilterData, FilterKey } from '../../types';

export const fetchAbundance = async (
    filterKey: FilterKey,
    options,
    onSuccess: (data: FilterData) => void,
    onFailed
) => {
    try {
        const experiments = joinExperimentsToString(
            window.growthbook,
            GrowthBookServerSideFeatures.MULTIPLE_SELECT
        );
        const response = await axios({
            method: 'GET',
            url: `/ajax/search-filters/${filterKey}/values?${getNonFalsyUrlSearchParams(options)}`,
            headers: {
                experiments: experiments,
            },
        });

        onSuccess(response.data);
    } catch (error) {
        onFailed(error);
    }
};
